<template>
    <div>
        <vxe-table-com
                v-if="subData.columns != undefined"
                :tableData="subData.data"
                :cols="subData.columns"
                ref="subTablsRef"
                :fixedNum="fixedNum"
                :key="renderTable"
                v-on:checkBoxSelectData="getSubBoxSelectData"
                v-on:selectRowData="dbSelectSubTableChange"
                :setGmcuid="subTableGmcuid"
                v-on:renderSearchVal="getredSearchVal"
                v-on:rederSub="GetrederSub"
                v-on:renderSortVal="getrenderSortVal"
                v-on:renderQueryVal="getrenderQueryVal"
                v-on:sortTableData="GetSortTableData"
                :loading="subLoading"
                :MaxHeight="useCaseHeight"
        >
            <template slot="topFunction">
                <div style="display: flex;justify-content: space-between;width: calc(100% - 10px);height: 35px;align-items: center;">
                    <div>
                        <function-bar
                                @handleToolClick="subEventclickCall"
                                :buttonsObj="subFunctionBtn"
                        ></function-bar>
                    </div>
                    <div v-if="subData.paging != null">
                        <a-pagination
                                :showTotal="total => `${$t('generic.totalOf')} ${pagePadding.pagingTotal} ${$t('generic.Records')}`"
                                size="small"
                                :total="pagePadding.pagingTotal"
                                v-model="pagePadding.currentVal"
                                :pageSize.sync="pagePadding.pagingSize"
                                @change="tableChangePage"
                                @showSizeChange="onShowSizeChange"
                                showSizeChanger

                        />
                    </div>
                </div>
            </template>
        </vxe-table-com>
    </div>
</template>
<script>
    import functionBar from "./functionBar.vue";
    import { mapState } from "vuex";
    import vxeTableCom from "../../com/tmsSubTable.vue";
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    import cookie from "../../../api/cookie";
    import axios from "axios";

    export default{
        components:{
            functionBar,
            vxeTableCom
        },
        props:{
            tmsUseCaseData:{
                type: Object,
                default: () => {
                    return {};
                }
            },
            useCaseHeight:{
                type: Number,
                default: () => {
                    return 150;
                }
            }
        },
        computed: {
            ...mapState(["lang"])
        },
        watch:{
            tmsUseCaseData(){
                this.initTabelList();
            }
        },
        data(){
            return{
                //    很多参数没用后面在删
                addPalletVisible: false,
                headerFromData: {},
                importVisible: false, // import 传过去的数据
                importparams:{}, // import 传过去的数据
                tabsTitle: '', // 最听不显示的title
                activeKey: [], // 分组下标
                pagePadding: { pagingTotal: 0, currentVal: 1, pagingSize: 30 }, // 分页
                bathUpdatparams: {}, // bath updata 参数
                lookupParams: {}, // 转给lookup组件参数
                partversion: null, // 父表当前版本好 废弃
                subLoading: false, // tab 中表格加载开关
                form: this.$form.createForm(this),
                patt1: "^(0|[1-9][0-9]*|-[1-9][0-9]*)$", // 整数
                patt2: "^[0-9]+([.]{1}[0-9]+){0,1}$", // 非整数
                patt3: /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,64}$/, // 密码
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                newGroupSearch: [],
                tarGetId: "", // 纪律当前下拉数据避免重复请求
                targetEditUid: "", // 当前编辑的uid
                parSubselectData: [], // 当前请求的下拉数据
                partEditBtnfn: [], // 按钮内容 part Edit
                editTargetObj: {}, // 父表格的edit 按钮内容
                drawerVisible: false, // drawer开关
                animated: false, // 关闭动画
                targetActive: 'headerKey', // 当前tabs选中卡
                subFunctionBtn: [], // tab卡中表格 btn content
                renderTable: 0, // 是否重新渲染组件
                fixedNum: 0, // 需要固定
                subData: {}, // 子表格数据
                subCheckData: [], // sub表格checkbox 选中
                subTableGmcuid: null,
                subQueryUpdatas: {}, // 传给弹窗内容
                subvisible: false,
                subApiType: "add", // 子表 谈add 还是edit 弹窗
                defaultImg: "", // 图片
                MaxHeight: 0, // table 流体高度
                subTableFunType: "", // sort headersearch adv type
                subTableFunInfo: "",
                isExtraParam: '',
                isExtraParType: '',// add edit
            }
        },
        created(){
            this.initTabelList();
        },
        methods: {
            dbSelectSubTableChange(val){
                this.$emit('tmsSubTableTargetUid',val.uid)
            },
//           分页
            tableChangePage(val) {
                this.subLoading = true;
                this.pagePadding.currentVal = val;
                this.subTableFun();
            },
            onShowSizeChange(current, pageSize) {
                this.subLoading = true;
                this.pagePadding.currentVal = current;
                this.pagePadding.pagingSize = pageSize;
                this.subTableFun();
            },
            //    操作固定width 需要重新渲染组件
            GetrederSub(val) {
                this.fixedNum = val;
                this.renderTable = this.renderTable + 1;
            },
//            表格排序
            getrenderSortVal(val) {
                this.subTableFunType = "sort";
                this.subTableFunInfo = val;
                this.subLoading = true;
                this.pagePadding.currentVal = 1
                this.subTableFun();
            },
            //      sub table表头搜索
            getredSearchVal(val) {
                this.subTableFunType = "tle";
                this.subLoading = true;
                let scParams = [];
                val.forEach((v, i) => {
                    if (v.serVal) {
                        scParams.push({ key: v.uid, value: v.serVal });
                    }
                });
                this.subTableFunInfo = scParams;
                this.pagePadding.currentVal = 1
                this.subTableFun();
            },
            //    子表andvance search
            getrenderQueryVal(item) {
                this.subTableFunType = "qf";
                this.subTableFunInfo = item;
                this.pagePadding.currentVal = 1
                this.subTableFun();
            },
            //      何在一起
            subTableFun() {
                let params = {
                    functionUid: this.$route.query.funcUid,
                    gmcUid: this.subTableGmcuid,
                    language: this.lang,
                    userUid: this.$route.query.userUid,
                    paging: {
                        pageNum: this.pagePadding.currentVal,
                        pageSize: this.pagePadding.pagingSize
                    },
                    params: [{ key: "uid", value: this.tmsUseCaseData.uid }]
                };
                if (this.subTableFunType == "sort") {
                    params.userSortDtos = this.subTableFunInfo;
                } else if (this.subTableFunType == "tle") {
                    params.columnSearch = this.subTableFunInfo;
                } else if (this.subTableFunType == "qf") {
                    params.userSqlDto = this.subTableFunInfo.query;
                    params.userSqlDto.gmcUid = this.subTableGmcuid
                    params.template = this.subTableFunInfo.tml;
                }
                ajax.post(api.SKUSTAB, params).then(res => {
                    if (res.code == 200) {
                        this.subTableFunType = ''
                        if (res.data.tableListDto.paging != null) {
                            this.pagePadding.pagingTotal =
                                res.data.tableListDto.paging.totalPageSize;
                        }
                        this.subLoading = false;
                        this.subFunctionBtn = res.data.functionBtn;
                        let arrFn =  this.subFunctionBtn
                        for (let i in arrFn) {
                            let tt = arrFn[i].children;
                            for (let j in tt) {
                                if (tt[j].code == "BTN_EDIT") {
                                    tt[j].editFlag = "1";
                                }
                            }
                        }
                        this.subData = res.data.tableListDto
                        this.$emit('tmsSubTableTargetUid',this.subData.data[0].uid)
                        for(let i in  this.subData.columns){
                            for(let t in this.subTableFunInfo){
                                if(this.subTableFunInfo[t].key ==  this.subData.columns[i].label){
                                    this.subData.columns[i].serVal =this.subTableFunInfo[t].value
                                }
                            }
                        }
                    } else {
                        this.$message.warning(res.msg, 3);
                        this.subLoading = false;
                    }
                });
            },

            //      TAb初始化数据
            initTabelList() {
                this.initData()
            },
            initData(){
                this.subLoading = true;
                    let params = {
                        userUid: this.$route.query.userUid,
                        functionUid: this.$route.query.funcUid,
                        language: this.lang,
                        gmcUid: this.tmsUseCaseData.gmcUid,
                        paging: {
                            pageNum: this.pagePadding.currentVal,
                            pageSize: this.pagePadding.pagingSize
                        },
                        params: [
                            {
                                key: "uid",
                                value: this.tmsUseCaseData.uid
                            }
                        ]
                    };
                    ajax.post(api.SKUSTAB, params).then(res => {
                        if (res.code == 200) {
                            if (res.data.tableListDto.paging != null) {
                                this.pagePadding.pagingTotal = res.data.tableListDto.paging.totalPageSize;
                            }
                            this.subLoading = false;
                            this.subTableGmcuid = res.data.gmcUid;
                            this.subFunctionBtn = res.data.functionBtn;
                            let arrFn =  this.subFunctionBtn
                            for (let i in arrFn) {
                                let tt = arrFn[i].children;
                                for (let j in tt) {
                                    if (tt[j].code == "BTN_EDIT") {
                                        tt[j].editFlag = "1";
                                    }
                                }
                            }
                            this.subData = res.data.tableListDto;
                            this.$emit('tmsSubTableTargetUid',this.subData.data[0].uid)
                        } else {
                            this.$message.warning(res.msg, 5);
                            this.subLoading = false;
                            return;
                        }
                    })
            },
            //      获取子表格选中返回的值
            getSubBoxSelectData(v) {
                this.subCheckData = v;
            },
            //    子按钮事件
            subEventclickCall(val) {
                // update 更新
                let that = this
                if (val.code == "BTN_REFRESH") {
                    this.subTableFun();
                }
                if (val.code === "BTN_UPDATE"){
                    if (this.subCheckData.length < 1) {
                        this.$message.warning(this.$t('publicLang.PleaseSltAtleast'), 5);
                        return;
                    }
                    let that = this;
                    this.$confirm({
                        title: that.$t('publicLang.AreUpadte'),
                        content: "",
                        onOk() {
                            let deleteData = that.subCheckData;
                            let paramsData = [];
                            for (let index in deleteData) {
                                if (deleteData[index].uid != "") {
                                    let paramsObj = {};
                                    paramsObj.key = "uid";
                                    paramsObj.value = deleteData[index].uid;
                                    paramsData.push(paramsObj);
                                    paramsData.push({
                                        key: "version",
                                        value: deleteData[index].version
                                    });
                                }
                            }
                            let params = {
                                gmcUid: val.pattern.gmcUid,
                                params: paramsData,
                                type: "update",
                                language: that.lang,
                                behrUid: val.btnUid
                            };
                            ajax.post(api.UPDATE, params).then(res => {
                                if (res.code === 200) {
                                    that.$message.success(res.msg);
                                    that.subTableFun();
                                } else {
                                    that.$message.warning(res.msg);
                                    that.$info({
                                        title: res.msg,
                                        okText: "Yes",
                                        okType: "danger",
                                        cancelText: "No",
                                        onOk() {
                                            that.subTableFun();
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
                //        新增操作
                if (val.code === "BTN_ADD") {
                    let params = {
                        gmcUid: val.pattern.gmcUid,
                        language: this.lang,
                        partnerType: this.isExtraParam
                    };
                    ajax.post(api.POPUP, params).then(res => {
//            是否内部编辑
                        if(val.isModel == false){
                            this.subvisible = false;
                        }else{
                            this.subvisible = true;
                        }

                        this.subApiType = "add";
                        this.subQueryUpdatas = res;
                        this.subQueryUpdatas.behrUid = val.btnUid;
                        this.subQueryUpdatas.uid = this.targetUID;
                        this.subQueryUpdatas.lookupGmcuid = val.pattern.gmcUid;
                        this.subQueryUpdatas.lookupCode = val.code;
                    });
                }
                if (val.code === "BTN_EDIT") {

                    if (this.subCheckData.length != 1) {
                        this.$message.warning(this.$t('publicLang.pleaseOneOnly'), 5);
                        return;
                    }
                    let paramsData = [];
                    let dataValues = this.subCheckData[0];
                    let params = {
                        gmcUid: val.pattern.gmcUid,
                        dataUid: dataValues.uid,
                        language: this.lang
                    };
                    ajax.post(api.POPUP, params).then(res => {
                        this.subApiType = "edit";
                        this.subvisible = true;
                        this.subQueryUpdatas = res;
                        this.subQueryUpdatas.behrUid = val.btnUid;
                        this.subQueryUpdatas.dataUid = params.dataUid;
                        this.subQueryUpdatas.lookupGmcuid = val.pattern.gmcUid;
                        this.subQueryUpdatas.lookupCode = val.code;
                        this.subQueryUpdatas.version = dataValues.version;
                    });
                }
                if (val.code === "BTN_DELETE") {
                    if (this.subCheckData.length < 1) {
                        this.$message.warning(this.$t('publicLang.PleaseSltAtleast'), 5);
                        return;
                    }
                    let tt = [];
                    for (let ii in this.subCheckData) {
                        if (!this.subCheckData[ii].deletable) {
                            tt.push(this.subCheckData[ii].key + 1);
                        }
                    }
                    if (tt.length > 0) {
                        let cc;
                        cc = tt.join(",");
                        this.$message.warning(
                            "[Row#"+cc+']'+this.$t('publicLang.NotAllowtodeleteCancel'),
                            5
                        );
                        return;
                    }
                    let that = this;
                    this.$confirm({
                        title: this.$t('pubGicSet.AreyoudeleTask'),
                        content: "",
                        onOk() {
                            let deleteData = that.subCheckData;
                            let paramsData = [];
                            for (let index in deleteData) {
                                if (deleteData[index].uid != "") {
                                    let paramsObj = {};
                                    paramsObj.key = "uid";
                                    paramsObj.value = deleteData[index].uid;
                                    paramsData.push(paramsObj);
                                    paramsData.push({
                                        key: "version",
                                        value: deleteData[index].version
                                    });
                                }
                            }
                            let params = {
                                gmcUid: val.pattern.gmcUid,
                                params: paramsData,
                                type: "delete",
                                language: that.lang,
                                behrUid: val.btnUid
                            };
                            ajax.post(api.UPDATE, params).then(res => {
                                if (res.code === 200) {
                                    that.subTableFun();
                                } else {
                                    that.$message.warning(res.msg);
                                    that.$info({
                                        title: res.msg,
                                        okText: "Yes",
                                        okType: "danger",
                                        cancelText: "No",
                                        onOk() {
                                            that.subTableFun();
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
                if (val.code == "BTN_EXPORT") {
                    if (val.patternType == "EXT") {
                        let ajaxurl = ajax.ajaxUrl();
                        axios.get(ajaxurl + val.externalApi, {
                            params: {
                                btnUid: val.btnUid,
                                language: this.lang
                            },
                            headers: {
                                Authorization: cookie.getBearerToken()
                            },
                            responseType: "blob" //二进制流
                        })
                            .then(function(data) {
                                if (!data) {
                                    return;
                                }
                                var blob = new Blob([data.data], {
                                    type:
                                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                                });
                                var url = window.URL.createObjectURL(blob);
                                var aLink = document.createElement("a");
                                aLink.style.display = "none";
                                aLink.href = url;
                                aLink.setAttribute("download", "excel.xlsx");
                                document.body.appendChild(aLink);
                                aLink.click();
                                document.body.removeChild(aLink); //下载完成移除元素
                                window.URL.revokeObjectURL(url); //释放掉blob对象
                            })
                            .catch(function(error) {
                                alert(error);
                            });
                    }

                    if(val.viewType == "EXCEL"){
                        let params = {
                            gmcUid: this.subTableGmcuid,
                            language: this.lang,
                            export: 'excel',
                            params:[{"key":"uid","value":this.targetUID}]
                        }


                        if(this.subTableFunInfo instanceof Array ){
                            params.columnSearch = this.subTableFunInfo
                        }else{
                            params.userSqlDto = this.subTableFunInfo.query
                        }
                        let ajaxurl = ajax.ajaxUrl();
                        ajax.exportExcel(ajaxurl+api.SKUS,params).then(data=>{
                            if (!data) {
                                return;
                            }
                            var blob = new Blob([data.data], {
                                type:
                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                            });
                            var url = window.URL.createObjectURL(blob);
                            var aLink = document.createElement("a");
                            aLink.style.display = "none";
                            aLink.href = url;
                            aLink.setAttribute("download", "excel.xlsx");
                            document.body.appendChild(aLink);
                            aLink.click();
                            document.body.removeChild(aLink); //下载完成移除元素
                            window.URL.revokeObjectURL(url); //释放掉blob对象
                        })
                    }
                }
                if (val.code == "BTN_SAVE") {
                    //            弹指定弹窗
                    if(val.type == "POPUP" && val.pattern.custPage == "lookUp"){
                        if (this.subCheckData.length != 1) {
                            this.$message.warning(this.$t('publicLang.pleaseOneOnly'), 3);
                            return;
                        }
                        let feildArr = []
                        let dataValues = this.subCheckData[0]
                        let feildPatternParams = val.pattern.params
                        for (let ii in dataValues) {
                            for (let tt in feildPatternParams) {
                                if (ii == feildPatternParams[tt]) {
                                    feildArr.push({key: ii, value: dataValues[ii].value})
                                }
                            }
                        }
                        let params = {
                            gmcUid: this.subTableGmcuid,
                            language: this.lang,
                            noEvent: true,
                            lookup: {
                                gmcUid: val.pattern.gmcUid,
                            }
                        }
                        params.feildArr = feildArr
                        this.lookupParams = params;
                        this.$refs.lookupRefs.showModal();
                    }
                    if(val.type == "BUTTON" && val.pattern.custPage == "enigeSort"){
                        let obj = {
                            tableId: this.subTableGmcuid
                        }
                        this.$refs.sortTableRef.show(obj)
                    }
                    if (val.pattern.custPage == "De-allocation" && val.type == "BUTTON") {
                        if (this.subCheckData.length < 1) {
                            this.$message.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                            return;
                        }
                        let params = [];

                        for (let ii in this.subCheckData) {
                            params.push(this.subCheckData[ii].uid);
                        }

                        this.$refs.deAllocation.openModal(params);
                    }
                    if (val.pattern.custPage == "Batch_Update" && val.type == "BUTTON") {
                        if (this.subCheckData.length < 1) {
                            this.$message.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                            return;
                        }
                        let Batchdata = this.subCheckData;
                        let batchDataArr = [];
                        for (let index in Batchdata) {
                            if (Batchdata[index].uid != "") {
                                let paramsObj = {};
                                paramsObj.key = "uid";
                                paramsObj.value = Batchdata[index].uid;
                                batchDataArr.push(paramsObj);
                                batchDataArr.push({
                                    key: "version",
                                    value: Batchdata[index].version
                                });
                            }
                        }
                        this.bathUpdatparams = {
                            gmcUid: val.pattern.gmcUid,
                            language: this.lang,
                            batchDataArr: batchDataArr,
                            btnUid: val.btnUid
                        };
                        this.$refs.subBathUpdateRefs.open();
                    }
                    if (val.type == "BUTTON" && val.patternType == "EXT") {
                        let paramsData = [];
                        if (val.pattern.params.length > 0) {
                            if (this.subCheckData.length < 1) {
                                this.$message.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                                return;
                            }
                            let SaveData = this.subCheckData;
                            let patterParams = val.pattern.params;
                            for (let index in SaveData) {
                                if (SaveData[index].uid != "") {
                                    let paramsObj = {};
                                    paramsObj.key = "uid";
                                    paramsObj.value = SaveData[index].uid;
                                    paramsData.push(paramsObj);
                                }
                            }
                        }
                        let params = {
                            behrUid: val.btnUid,
                            userUid: this.$route.query.userUid,
                            functionUid: this.$route.query.funcUid,
                            gmcUid: val.pattern.gmcUid,
                            params: paramsData,
                            language: this.lang
                        };
                        ajax.post(val.externalApi, params).then(res => {
                            if (res.code == 200) {
                                this.subTableFun();
                                this.$message.success(res.msg, 5);
                            } else {
                                this.$message.warning(res.msg, 5);
                            }
                        });
                    }
                    if(val.pattern.custPage == "Split" && val.type == "BUTTON"){
                        if (this.subCheckData.length != 1) {
                            this.$message.warning(this.$t('publicLang.pleaseOneOnly'), 3);
                            return;
                        }else{
                            this.$refs.splitRef.showSplit(this.subCheckData[0].uid)
                        }
                    }
                    if (val.type == "BUTTON" && val.pattern.custPage == "Sort"){
                        this.$refs.modalSortTableRef.show(this.subData.columns,this.subData.data,this.subTableGmcuid )
                    }
                    if (val.type == "BUTTON" && val.pattern.custPage == "editTable"){ // receive deatil table 快速
                        this.$refs.editTableRef.show(this.targetUID)
                    }
                    if (val.type == "BUTTON" && val.pattern.custPage == "CreateFromInventory"){
                        this.$refs.createFromInventory.show(this.targetUID)
                    }
                    if (val.type == "BUTTON" && val.pattern.custPage == "soEditTable"){
                        this.$refs.soEditTableRef.show(this.targetUID)
                    }
                    if (val.type == "BUTTON" && val.pattern.custPage == "quick-Allocation"){
                        this.$refs.soAllocationTabRef.show(this.targetUID)
                    }
                    if (val.type == "BUTTON" && val.pattern.custPage == "createPallet"){
                        if (this.subCheckData.length < 1) {
                            this.$message.warning(this.$t('publicLang.PleaseSltAtleast'), 5);
                            return;
                        }
                        let uids = [];
                        for (let index in this.subCheckData){
                            uids.push(this.subCheckData[index].uid)
                        }
                        this.$refs.addConsignmentRefs.show('ULD#','createPallet',uids)
                    }
                    if (val.type == "BUTTON" && val.pattern.custPage == "createShipment"){
                        if (this.subCheckData.length < 1) {
                            this.$message.warning(this.$t('publicLang.PleaseSltAtleast'), 5);
                            return;
                        }
                        let uids = [];
                        for (let index in this.subCheckData){
                            uids.push(this.subCheckData[index].uid)
                        }
                        this.$refs.addConsignmentRefs.show('MAWB','createShipment',uids)
                    }
                    if (val.type == "BUTTON" && val.pattern.custPage == "palletDetail"){
                        let params = {
                            btnUid: val.btnUid,
                            userUid: this.$route.query.userUid,
                            language: this.lang,
                            fieldMapUid: val.mapUid,
                            importTitle: val.name,
                            targetUID: this.targetUID,
                            gmcUid: val.pattern.gmcUid,
                            palletType: 'palletDetail'
                        };
                        this.importparams = params;
                        this.addPalletVisible = true;
                    }
                    if (val.type == "BUTTON" && val.pattern.custPage == "shipmentDetail"){
                        let params = {
                            btnUid: val.btnUid,
                            userUid: this.$route.query.userUid,
                            language: this.lang,
                            fieldMapUid: val.mapUid,
                            importTitle: val.name,
                            targetUID: this.targetUID,
                            gmcUid: val.pattern.gmcUid,
                            palletType: 'shipmentDetail'
                        };
                        this.importparams = params;
                        this.addPalletVisible = true;
                    }
                }
                if (val.code == "BTN_IMPORT") {
                    let params = {
                        btnUid: val.btnUid,
                        userUid: this.$route.query.userUid,
                        language: this.lang,
                        fieldMapUid: val.mapUid,
                        importTitle: val.name,
                        isMove: val.pattern.custPage,
//              子表inport 需要父表uid
                        targetUID: this.targetUID
                    };
                    if (val.type == "POPUP" && val.viewType == "LIST") {
                        params.importType = "DB";
                        params.gmcUid = val.pattern.gmcUid;
                    }
                    if (val.type == "File" && val.viewType == "EXCEL"){
                        params.importType = "excel";
                        params.gmcUid = val.pattern.gmcUid;
                    }
                    this.importparams = params;
                    this.importVisible = true;
                }
            },
//    sortTable 成功刷新
            GetSortTableData(v){
                if(v == 'columnSetting'){
                    this.subData = {}
                }
                this.initTabelList();
            },

        }
    }
</script>